import { useId } from "react";

// Custom cloud-upload glyph with a gradient fill + inner highlight so it reads
// as a small 3D badge instead of a flat lucide icon — used only on Upload
// Documents buttons so that specific CTA stands out from every other icon on the page.
export const UploadIcon3D = ({ className = "h-5 w-5", from = "#fde68a", to = "#d4a24c" }) => {
  const gradId = useId();
  return (
    <svg viewBox="0 0 40 40" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id={`${gradId}-body`} x1="6" y1="6" x2="34" y2="34" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor={from} />
          <stop offset="1" stopColor={to} />
        </linearGradient>
        <linearGradient id={`${gradId}-arrow`} x1="20" y1="14" x2="20" y2="30" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#ffffff" />
          <stop offset="1" stopColor="#ffffff" stopOpacity="0.85" />
        </linearGradient>
      </defs>

      {/* drop shadow ellipse for a lifted, 3D feel */}
      <ellipse cx="20" cy="33.5" rx="10" ry="2" fill="#000000" opacity="0.12" />

      {/* cloud body */}
      <path
        d="M12.5 26C9 26 6 23.2 6 19.7c0-3.2 2.4-5.8 5.5-6.2C12.6 9.9 16 7.5 20 7.5c4.4 0 8 2.9 9 6.9 3.4.5 6 3.4 6 6.9 0 3.9-3.1 7-7 7H12.5z"
        fill={`url(#${gradId}-body)`}
      />
      {/* top-left highlight for depth */}
      <path
        d="M12.5 26c-2.6 0-4.8-1.5-5.7-3.7 1 2.6 3.6 4 6.3 4H18v-0.3z"
        fill="#ffffff"
        opacity="0.18"
      />

      {/* upward arrow */}
      <path d="M20 30V15" stroke={`url(#${gradId}-arrow)`} strokeWidth="3" strokeLinecap="round" />
      <path d="M14.5 19.5 20 14l5.5 5.5" stroke={`url(#${gradId}-arrow)`} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
